module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "images",
    attrs: {
      "id": "image3"
    }
  }, [_c('p', {
    staticClass: "booktitle"
  }, [_vm._v("MOROCCO")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("A Culinary Journey with Recipes"), _c('br'), _vm._v("from the Spice–Scented Markets of Marrakech"), _c('br'), _vm._v("to the Date–Filled Oasis of Zagora")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('strong', [_c('em', [_vm._v("text and photographs by")]), _c('br'), _vm._v("JEFF KOEHLER")])]), _vm._v(" "), _c('p', {
    staticClass: "publogo"
  }, [_c('img', {
    attrs: {
      "alt": "Chronicle Books",
      "src": "images/logo.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e87753f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003titlepage.vue
// module id = 60
// module chunks = 0